<script lang="ts">

    import type {Community} from "../models/model";

    export let communityData: Community | null = null;
    import {_} from '../services/i18n';
    import Time from "svelte-time";
    import CycleChart from "./CycleChart.svelte";
</script>

<div class="list-wrapper">


    {#if communityData?.dateOfSignaturePact}
        <div class="list-item">
            <label>{$_('pact.dateOfSignaturePact')}:</label>
            <span><Time timestamp={communityData?.dateOfSignaturePact} format="DD.MM.YYYY"/></span>

        </div>
    {/if}
    <div class="list-item">
        <label>{$_('pact.currentCycle')}:</label>
        <span>
            {#if communityData?.dateOfSignaturePilotPact && communityData?.pilotPactEndDate}
            {communityData?.cycles_count - 1}
                {:else}
            {communityData?.cycles_count}
                {/if}
            <!--
          <CycleChart count={communityData?.cycles_count}></CycleChart>
          -->
        </span>
    </div>
    {#if communityData?.dateOfSignaturePilotPact}
        <div class="list-item">
            <label>{$_('pact.dateOfSignaturePilotPact')}:</label>
            <span>
        <span><Time timestamp={communityData?.dateOfSignaturePilotPact} format="DD.MM.YYYY"/></span>
                {#if communityData?.pilotPactEndDate}
            <span style="margin-left:2px; margin-right:2px;">-</span><span><Time
                        timestamp={communityData?.pilotPactEndDate} format="DD.MM.YYYY"/></span>
        {/if}
            </span>
        </div>
    {/if}


</div>

<style lang="scss">

  .list-wrapper {

    display: flex;
    flex-direction: column;
    //row-gap:20px;


    .list-item {

      display: flex;
      justify-content: space-between;
      border-bottom: 2px dashed #F8F7F7;
      column-gap: 20px;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;

      label {
        //background: red;

      }

      span {
        align-items: center;
        display: flex;
        //background: yellow;
      }

      a {

        color: inherit;

      }

    }

  }

  @media (max-width: 680px) {

    .list-wrapper {
      .list-item {
        flex-direction: column;
        align-items: flex-start;

        label {
          font-weight: bold;
        }
      }
    }
  }


</style>
